var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Smiley"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 28.1885C22.6274 28.1885 28 22.8159 28 16.1885C28 9.56106 22.6274 4.18848 16 4.18848C9.37258 4.18848 4 9.56106 4 16.1885C4 22.8159 9.37258 28.1885 16 28.1885Z",
    stroke: "#898989",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.1973 19.1885C20.6701 20.1003 19.9124 20.8573 19.0001 21.3836C18.0879 21.91 17.0532 22.187 16 22.187C14.9468 22.187 13.9122 21.91 12.9999 21.3837C12.0876 20.8574 11.3299 20.1003 10.8027 19.1886",
    stroke: "#898989",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 13.6885C12 13.9646 11.7761 14.1885 11.5 14.1885C11.2239 14.1885 11 13.9646 11 13.6885C11 13.4123 11.2239 13.1885 11.5 13.1885C11.7761 13.1885 12 13.4123 12 13.6885Z",
    stroke: "#898989",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21 13.6885C21 13.9646 20.7761 14.1885 20.5 14.1885C20.2239 14.1885 20 13.9646 20 13.6885C20 13.4123 20.2239 13.1885 20.5 13.1885C20.7761 13.1885 21 13.4123 21 13.6885Z",
    stroke: "#898989",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.d28d864bf430fe2a5666911ec65c4482.svg";
export { ForwardRef as ReactComponent };